import { useLiveQuery } from 'dexie-react-hooks';
import { db } from '../db/index.js';
import { buildTree, liveDecks } from '../db/repo/decks.js';
import { computeAllCounts } from '../scheduler/queue.js';
import { useNow } from './useNow.js';

export function useDecks() {
  return useLiveQuery(() => db.decks.toArray(), [], null);
}

/** Deck tree with today's due counts; refreshes as data or time changes. */
export function useDeckOverview() {
  const now = useNow(60000);
  const minute = Math.floor(now / 60000);
  return useLiveQuery(
    async () => {
      const decks = await db.decks.toArray();
      const cards = (await db.cards.toArray()).filter((c) => !c.deletedAt);
      const counts = computeAllCounts(decks, cards, Date.now());
      return { decks, live: liveDecks(decks), tree: buildTree(decks), counts };
    },
    [minute],
    null,
  );
}
